/** Displays a Font-Awesome edit icon (fa-info-circle) */
export const infoIconFormatter = () => `<i class="fa fa-info-circle pointer info-icon" aria-hidden="true"></i>`;
//# sourceMappingURL=infoIconFormatter.js.map